// Bilingual (Hebrew / Arabic) content for the Standing Together pages.
// Each entry is { he, ar }. Content transcribed from standing-together.org.

// Join-the-movement membership page (the home route "/")
export const join = {
  heading: { he: 'כאן מצטרפים לעומדים ביחד', ar: 'هنا يمكنك الإنضمام لنقف معًا' },
  amountQuestion: { he: 'בכמה תרצו להשתתף לחודש?', ar: 'بكم تريدون المساهمة شهريًا؟' },
  monthlyAmounts: ['18', '27', '50', '99', '150', '250'],
  other: { he: 'אחר', ar: 'آخر' },
  minAmount: 1,
  minNote: {
    he: 'סכום השתתפות מינימלי לחודש: 5 ₪',
    ar: 'الحد الأدنى للاشتراك، 5 ₪',
  },
  perMonth: { he: 'בחודש', ar: 'شهريًا' },
  next: { he: 'הבא', ar: 'التالي' },
  chosen: { he: 'סכום חודשי שנבחר:', ar: 'المبلغ الشهري الذي تم اختياره:' },
  changeAmount: { he: 'שינוי סכום', ar: 'تغيير المبلغ' },
  send: { he: 'מעבר לתשלום', ar: 'الانتقال إلى الدفع' },
  coverFee: {
    // {amount} is substituted with the fee ALREADY formatted in the donation's
    // currency (formatAmount in currencies.js) — the symbol isn't part of the
    // string any more, because it isn't always a shekel.
    he: 'אשמח להוסיף {amount} לכיסוי עמלת הסליקה',
    ar: 'أرغب في إضافة {amount} لتغطية رسوم معالجة الدفع',
  },
  secureNotice: {
    he: 'התשלום מופעל על ידי ישראל תורמת בע"מ ומאובטח בתקן PCI',
    ar: 'تتم معالجة الدفع من خلال شركة "إسرائيل توريمت"، وتتم حماية المعلومات وفق معيار PCI',
  },
  processing: { he: 'שולח...', ar: 'جارٍ الإرسال...' },
  fields: {
    firstName: { he: 'שם פרטי', ar: 'الاسم الشخصي' },
    lastName: { he: 'שם משפחה', ar: 'اسم العائلة' },
    address: { he: 'כתובת', ar: 'العنوان' },
    city: { he: 'יישוב מגורים', ar: 'مكان الاقامة' },
    phone: { he: 'טלפון', ar: 'رقم الهاتف' },
    birthYear: { he: 'שנת לידה', ar: 'سنة الولادة' },
    email: { he: 'דואר אלקטרוני', ar: 'البريد الالكتروني' },
    student: { he: 'אני סטודנט/ית', ar: 'انا طالب/ة' },
    institution: { he: 'מוסד אקדמי', ar: 'مؤسسة أكاديميّة' },
    fieldOfStudy: { he: 'חוג לימודים', ar: 'موضوع' },
    card: { he: 'מספר אשראי', ar: 'رقم بطاقة الاعتماد' },
    expiry: { he: 'תוקף', ar: 'الصلاحية' },
    cvv: { he: 'קוד אימות', ar: 'رمز التحقق' },
  },
  consent: {
    he: 'במעבר לתשלום אני מסכים/ה ',
    heTerms: 'לתנאי השימוש',
    ar: 'بالانتقال إلى الدفع، أوافق على ',
    arTerms: 'شروط الاستخدام',
  },
  error: { he: 'שגיאה. אנא בדקו את הטופס ונסו שנית', ar: 'حصل خلل. يرجى فحص النموذج من جديد' },
  thanks: { he: 'תודה!', ar: 'شكرًا!' },
  thanksBody: {
    he: 'ברגעים הקרובים ישלח אליך מייל אישור.',
    ar: 'سيصلك بريد تأكيد خلال لحظات.',
  },
  sections: [
    {
      variant: 'intro',
      title: { he: 'אנחנו לא מוותרים על התקווה לבנות מציאות טובה יותר.', ar: 'لا نتخلى عن الأمل في بناء واقع أفضل.' },
      body: {
        he: 'בזכות החברים שלנו, יהודים וערבים, אנחנו בדיוק איפה שצריך אותנו, בשטח ובקהילה.\nחברות חודשית נותנת לנו גב - כדי שנהיה שם גם מחר.\nהצטרפו לתנועת עומדים ביחד, גם תרומה חודשית קטנה, עושה שינוי גדול.',
        ar: 'بفضل الأعضاء، كيهود وعرب، نحن في المكان الذي نحتاج أن نكون فيه، في الميدان وداخل المجتمع.\nالعضوية الشهرية تمنحنا الدعم كي نكون هناك غدًا أيضًا.\nانضموا إلى حراك "نقف معًا"، حتى مساهمة شهرية صغيرة تصنع تغييرًا كبيرًا.',
      },
    },
    {
      variant: 'bar',
      title: { he: 'מה זה אומר להיות חבר/ה בתנועה?', ar: 'ماذا يعني أن تكون/ي عضو/ة حراك؟' },
      body: { he: '', ar: '' },
      // Cards shown in the expanded panel. `lead` is highlighted purple; `body` is black.
      cards: [
        {
          img: '/images/about_1.avif',
          lead: {
            he: 'חברי וחברות תנועת עומדים ביחד נמצאים בכל הארץ,',
            ar: 'أعضاء وعضوات حراك نقف معًا متواجدون في كافة أنحاء البلاد،',
          },
          body: {
            he: 'במרכז ובפריפריה, אנחנו צעירים ומבוגרים, ערביות ויהודיות, נשים וגברים, ממגוון הקהלים שמרכיבים את הפסיפס החברתי של החברה שלנו כאן.',
            ar: 'في المركز والضواحي، نحن شباب وكبار السن، عربيات ويهوديات، نساء ورجال، من مختلف الشرائح والفئات التي تكوّن الفسيفساء المجتمعي لمجتمعنا هنا.',
          },
        },
        {
          img: '/images/about_2.avif',
          lead: {
            he: 'אנחנו, חברי וחברות עומדים ביחד - פועלים ביחד במעגלים המקומיים,',
            ar: 'نحن، الرفاق والرفيقات في نقف معًا - ننشط معًا في إطار حلقات محلية،',
          },
          body: {
            he: 'בצוותי עבודה של מאבקים, מתכננים אסטרטגיה לקמפיינים עירוניים וארציים, עוברים הכשרות כדי לקבל עוד כלים לעשייה שלנו, דנים בסוגיות הפוליטיות של החברה שלנו ומתארגנים ביחד למען שלום, שוויון וצדק חברתי.',
            ar: 'في طواقم عمل على النضالات المختلفة، نضع استراتيجية للحملات المحلية والقُطرية، نشارك بورشات تدريبية لاكتساب المزيد من الأدوات التي تخدم نشاطنا، نناقش قضايا سياسية تخص مجتمعنا ونتنظّم معًا من أجل السلام، المساواة والعدالة الاجتماعية.',
          },
        },
        {
          img: '/images/about_3.avif',
          lead: {
            he: 'אנחנו הבעלים של התנועה',
            ar: 'نحن أصحاب الحراك',
          },
          body: {
            he: 'ובוחרים בנציגים שלנו לצוות התיאום שמנהל את העשייה של התנועה. אנחנו יכולים לייצר פעילות אוטונומית במעגלים שלנו - ודרך הנציגים שלנו, יכולים להשפיע על הדרך וסדר העדיפויות של התנועה באופן ארצי.',
            ar: 'وننتخب ممثلينا لطاقم التنسيق الذي يدير عمل الحراك. يمكننا أن ننتج نشاطات مستقلة في إطار حلقاتنا - ومن خلال ممثلينا، يمكننا التأثير على نهج وأولويات الحراك على النطاق القُطري.',
          },
        },
        {
          img: '/images/about_4.avif',
          lead: {
            he: 'ביחד אנחנו בונים כוח',
            ar: 'معًا نبني القوة',
          },
          body: {
            he: '- את יכולת ההשגה של המטרות שלנו. כשאנחנו רבים, כך גדלים הכוח וההשפעה שלנו על המציאות בה אנחנו חיים. כל אחד ואחת מאיתנו הוא נכס לתנועה. כך גם את ואתה.',
            ar: '- القدرة على تحقيق أهدافنا. كلّما كنّا أكثر، تكبر قوتنا وتأثيرنا على الواقع الذي نعيش فيه. كل واحد وواحدة منا هو كنز للحراك. وكذلك أنتِ وأنتَ.',
          },
        },
      ],
      // Accordion tabs shown below the cards.
      tabs: [
        {
          title: { he: 'מי אנחנו?', ar: 'من نحن؟' },
          logo: '/images/logo-purple.png',
          body: {
            he: 'עומדים ביחד היא תנועה שנאבקת למען עתיד בטוח בארץ, למען שיטה שסופרת את כולנו, למען חיים בכבוד, בצדק חברתי ובשלום. כי למרות שאנחנו באים ממקומות שונים, למרות שיש לנו זהויות שונות - האינטרסים שלנו משותפים. זה נכון לכולנו, ערבים ויהודים, וזה הופך אותנו לרוב. בעומדים ביחד אנחנו מתארגנים, בונים כוח, ובונים תנועה שתוביל את הדרך לשם. הצטרפו אלינו.',
            ar: 'نقف معًا هو حراك يناضل من أجل مستقبل آمن في البلاد، من أجل نظام يهمنا جميعًا، من أجل حياة كريمة وعدالة اجتماعية وسلام. لأنه على الرغم من أننا نأتي من أماكن مختلفة، على الرغم من اختلاف هوياتنا - فإن اهتماماتنا مشتركة. هذا صحيح بالنسبة لنا جميعًا كعرب ويهود، وهو يجعلنا أغلبية. في نقف معًا، نتنظم ونبني القوة ونبني حراكًا سيقود الطريق إلى هناك. انضموا إلينا.',
          },
        },
        {
          title: { he: 'למה להצטרף לתנועה?', ar: 'لماذا الانضمام للحراك؟' },
          body: {
            he: 'כדי לעשות שינוי! כדי להשיג שינוי גדול בחברה שלנו – אנחנו צריכים לבנות כוח גדול. כזה שיוביל מאבקים, יצביע על האלטרנטיבה, ויתעקש שאפשר אחרת גם בימים קשים. בעומדים ביחד תמצאו עוד חברות וחברים שמאמינים באותם ערכים כמוכם. אנחנו צריכים להיות ביחד, כדי שנוכל ללמוד אחד מהשנייה, להתחזק, ואז להוביל ביחד את השינוי שאנחנו רוצות ורוצים לראות. אם נבנה ביחד תנועה גדולה לשינוי, אי-אפשר יהיה לעצור אותנו.',
            ar: 'من أجل صنع التغيير! من أجل تحقيق تغيير عظيمٍ في مجتمعنا - نحن بحاجة لبناء قوة كبيرة تتزايد مع انضمام كل عضوٍ جديدٍ للحراك، يسدد رسوم عضوية لميزانيتنا المشتركة. حراكنا ديمقراطي: كرفيقة في الحراك، سيكون بإمكانكِ التصويت على نقاط تتعلق بطريق الحراك وخطّه، وانتخاب قيادته كذلك. ولا تكمن قوتنا في رسوم العضوية التي تتيح لنا العمل باستقلاليةٍ فحسب، بل إن مصدر قوتنا يتمثل بنا نحن. عندما ننشط ونعمل معًا، نتعلّم ونستفيد أحدنا من الآخر، نضع معًا إستراتيجيات ونضالات محلّية وقُطرية، تزداد قوتنا، وبعدها نسير معًا نحو مجتمع وسياسة جديدة في إسرائيل، ترى وتأخذ بالحسبان جميع من يعيشون هنا.',
          },
        },
        {
          title: { he: 'למה חשוב להתארגן?', ar: 'لمَ من المهم أن ننتظم؟' },
          body: {
            he: 'הדרך הכי טובה של השלטון לשמר את המצב הקיים – היא להפריד בינינו. להפריד בין קבוצות – יהודים נגד ערבים, אשכנזים נגד מזרחים, תושבי הפרירפריה נגד תושבי המרכז - ולהפריד בין אנשים, כדי שכל אחד יתרכז בחיים שלו, עד שנפסיק להאמין ששינוי הוא אפשרי. לכן אם אנחנו רוצים שינוי – אנחנו חייבים לפעול הפוך, ולהתארגן! התארגנות מגדילה את הכוח שלנו. לכל אחד מאיתנו יש כשרונות אחרים, כל אחת מביאה ידע אחר. אנחנו צריכים את כל הכשרונות האלו ואת כל הידע הזה כדי לנצח. לכן הקמנו את עומדים ביחד כמקום שאפשר להתארגן בו לפעולה – לשבור את ההפרדות בינינו, להכיר עוד אנשים שרוצים בשינוי, להחליט ביחד על הדרך, ואז לצעוד בה. כשאנחנו מאורגנים – אנחנו לא תלויים יותר באף-אחד אחר. התארגנות נותנת לנו את הכוח לעצב את העתיד שלנו, למען כולנו',
            ar: 'أفضل طريقة يستخدمها النظام للإبقاء على الوضع الراهن - هي التفرقة بيننا وشرذمتنا. التفرقة بين الفئات المختلفة - اليهود ضد العرب، الأشكناز ضد الشرقيين، سكان مركز البلاد ضد سكان ضواحيها - والتفرقة بين الأشخاص، ليهتم كل منّا لأموره وحياته فقط، إلى أن نكفّ عن الإيمان بأن التغيير ممكن. لذا فبحال أردنا أن نصنع التغيير - علينا أن نعمل على عكس ذلك: أن نتنظم ونخلق الشراكات الجديدة في المجتمع والتي تكون، مجتمعةً معًا، أقوى من السلطة. عندما نكون أقوياء نتمتع بالقوة السياسية، يمكننا تحقيق مطالبنا. ولا ترتكز هذه المقولة على نظرية معينة، إنما على تجارب كفاحية سابقة حصّلنا من خلالها دعمًا اقتصاديًا في فترة الكورونا، من النضال ضد الترحيل ومع جنوب تل-أبيب، ومن نضالات بيئية وغيرها.\nكل واحدٍ منّا يتمتع بمهارات تميزه عن غيره، كل واحدة منا تملك معرفةً تمتاز هي بها. نحن بحاجة لكل هذا المهارات والمعرفة لكي نحقق النصر. لذلك أنشأنا نقف معًا كمكان يمكن التنظّم للنشاط في إطاره.',
          },
        },
      ],
    },
    {
      variant: 'box',
      title: { he: 'למה אנחנו מבקשים מחברי התנועה תשלום של דמי חבר?', ar: 'لماذا نطلب من أعضاء الحراك أن يدفعوا رسوم عضوية؟' },
      body: {
        he: 'עומדים ביחד היא תנועה של אנשים - והיא גם נסמכת על אנשים. אנחנו לא מקבלים כסף מממשלות זרות, ובטח שלא מממשלת הימין בישראל. הדרך היחידה שלנו להבטיח שנוכל להמשיך לפעול - וגם לגדול - היא באמצעות דמי חבר ותרומות קטנות מכמה שיותר אנשים. אתם מוזמנים לבחור תרומה חודשית בכל סכום החל מ-5 ₪ בחודש.',
        ar: 'نقف معًا هو حراك من الناس- ويعتمد على الناس. نحن لا نحصل على أموال من حكومات أجنبية وطبعًا ليس من حكومة اليمين في اسرائيل. الطريقة الوحيدة كي نضمن استمرار نشاطاتنا - والتوسع - هي بمواسعة رسوم العضوية والتبرعات الصغيرة من أكبر عدد من الناس.',
      },
    },
  ],
  // Two bullet items shown below the bordered box.
  exemptionNote: {
    he: 'רוצה להצטרף לתנועה, אבל אין ביכולתך לשלם דמי חבר דרך כרטיס האשראי? צריך/ה פטור מדמי חבר? אפשר לפנות אלינו במייל - ',
    ar: 'مرحبًا، أود أن التحق بالحركة، ولكن لا يمكنني أن أدفع رسوم الدفع خلال بطاقة الإئتمان، بحاجة لإعفاء من رسوم الدفع؟ من الممكن التوجه إلينا عبر البريد الالكتروني التالي - ',
    email: 'info@standing-together.org',
  },
};

// Thank-you dialog shown after a successful donation or membership signup.
// Each variant has its own heading/subtitle and set of link buttons.
export const share = {
  donate: {
    thanks: { he: 'תודה!', ar: 'شكرًا!' },
    subtitle: {
      he: 'התרומה התקבלה בהצלחה',
      ar: 'تم استلام التبرع بنجاح',
    },
    // Social profiles shown as a 2-column icon grid; no per-language text needed.
    links: [
      { network: 'instagram', url: 'https://www.instagram.com/standing.together.movement/' },
      { network: 'facebook', url: 'https://www.facebook.com/standingtogether1/' },
      { network: 'tiktok', url: 'https://www.tiktok.com/@standingtogether' },
      { network: 'twitter', url: 'https://x.com/omdimbeyachad' },
      { network: 'whatsapp', url: 'https://api.whatsapp.com/send/?phone=972552462608&text=%D7%94%D7%99%D7%99+%D9%85%D8%B1%D8%AD%D8%A8%D8%A7&type=phone_number&app_absent=0' },
      { network: 'youtube', url: 'https://www.youtube.com/channel/UCPF6TkMJO9ZYxCX9hR71vOg' },
    ],
  },
  join: {
    thanks: { he: 'יש!', ar: 'رائع!' },
    subtitle: {
      he: 'הצטרפת כחבר/ה בעומדים ביחד',
      ar: 'لقد انتسبت كعضو/ة في نقف معًا',
    },
    subtitle2: {
      he: 'עכשיו הגיע הזמן להצטרף לפעילות.',
      ar: 'والآن حان الوقت لتنضم للنشاط أيضًا.',
    },
    links: [
      {
        he: 'הצטרפו לפעילות במעגל המקומי שלכם',
        ar: 'انضموا للنشاط في إطار حلقتكم المحلّية',
        url: 'https://www.standing-together.org/locals',
      },
      {
        he: 'הצטרפו לפעילות באוניברסיטאות ובמכללות',
        ar: 'انضموا للنشاط في الجامعات والكلّيات',
        url: 'https://www.standing-together.org/students',
      },
      {
        he: 'בואו לשיחה למצטרפים חדשים',
        ar: 'تعالوا للقاء تعارف مع الحراك',
        url: 'https://www.standing-together.org/newmembers',
      },
    ],
  },
  // Campaign pages: instead of profile links, four buttons that share the
  // campaign itself. The shared message comes from the campaign's Gramsci
  // record (share_message_he / share_message_ar); `defaultText` covers a
  // campaign that has neither.
  campaign: {
    thanks: { he: 'תודה!', ar: 'شكرًا!' },
    subtitle: { he: 'עכשיו שתפו', ar: 'والآن شاركوا' },
    // `lang` picks which language's message a button sends; the bilingual
    // buttons (Facebook / X) have none and go out in Hebrew.
    buttons: [
      { network: 'whatsapp', lang: 'he', he: 'שתפו בווטסאפ' },
      { network: 'whatsapp', lang: 'ar', ar: 'شاركوا بالواتساب' },
      { network: 'facebook', he: 'שתפו בפייסבוק', ar: 'شاركوا بالفيسبوك' },
      { network: 'twitter', he: 'שתפו בטוויטר', ar: 'شاركوا بتويتر' },
    ],
    defaultText: {
      he: 'תרמתי לקמפיין "{title}" של עומדים ביחד — הצטרפו גם אתם!',
      ar: 'تبرعت لحملة "{title}" لنقف معًا — انضموا أنتم أيضًا!',
    },
    // Optional personal message for the campaign's donor wall. Collected HERE,
    // after the charge, rather than in the donor form — one less field between
    // a donor and paying. Max 40 chars (also enforced server-side).
    messagePrompt: {
      he: 'אני רוצה להוסיף מסר אישי שיוצג בעמוד התרומה',
      ar: 'أريد إضافة رسالة شخصية تعرض في صفحة التبرع',
    },
    messageSubmit: { he: 'שליחת המסר', ar: 'إرسال الرسالة' },
    // Replaces the field once the message is in — the donor gets confirmation
    // without the dialog closing out from under the share buttons.
    messageSent: { he: 'המסר נשלח, תודה!', ar: 'تم إرسال الرسالة، شكرًا!' },
  },
};

// Dedicated one-time donation page (/donate)
export const donatePage = {
  title: { he: 'תרמו לפעילות שלנו', ar: 'تبرعوا لنشاطاتنا' },
  types: {
    once: { he: 'תרומה חד פעמית', ar: 'تبرع لمرة واحدة' },
    monthly: { he: 'תרומה חודשית', ar: 'تبرع شهري' },
  },
  onceAmounts: ['18', '45', '78', '100', '180', '250', '500'],
  monthlyAmounts: ['18', '27', '50', '78', '100', '250', '500'],
  perMonth: { he: 'בחודש', ar: 'شهريًا' },
  other: { he: 'סכום אחר', ar: 'مبلغ آخر' },
  next: { he: 'הבא', ar: 'التالي' },
  back: {
    he: 'חזרה לבחירת סכום או לשינוי סוג תרומה',
    ar: 'العودة لاختيار المبلغ أو تغيير نوع التبرع',
  },
  paymentOf: { he: 'תשלום בסך', ar: 'دفعة بمبلغ' },
  pay: { he: 'מעבר לתשלום', ar: 'الانتقال إلى الدفع' },
  coverFee: {
    // {amount} is substituted with the fee ALREADY formatted in the donation's
    // currency (formatAmount in currencies.js) — the symbol isn't part of the
    // string any more, because it isn't always a shekel.
    he: 'אשמח להוסיף {amount} לכיסוי עמלת הסליקה',
    ar: 'أرغب في إضافة {amount} لتغطية رسوم معالجة الدفع',
  },
  // Campaign pages only (CampaignPage.js). donate/join have no donor wall, so
  // there is nothing there for a donor to stay anonymous ON.
  anonymous: {
    he: 'אני מעדיף/ה לתרום בעילום שם',
    ar: 'أفضّل التبرع دون ذكر الاسم',
  },
  secureNotice: {
    he: 'התשלום מופעל על ידי ישראל תורמת בע"מ ומאובטח בתקן PCI',
    ar: 'تتم معالجة الدفع من خلال شركة "إسرائيل توريمت"، وتتم حماية المعلومات وفق معيار PCI',
  },
  processing: { he: 'מעבד תשלום...', ar: 'جارٍ المعالجة...' },
  donateNow: { he: 'תרמו עכשיו', ar: 'تبرعوا الآن' },
  whoWeAre: { he: 'מי אנחנו', ar: 'من نحن' },
  // Mobile screen 1 lead: only the closing sentence is purple, the rest is black.
  lead1: {
    he: 'עומדים ביחד היא תנועה של פעילים. אין מאחורינו בעלי הון. וגם לא ממשלות זרות. ',
    hePurple: 'בשביל לממן את הפעילות שלנו - אנחנו צריכים אתכן ואתכם.',
    ar: 'نقف معًا هو حراك مكون من ناشطين. لا يوجد في ظهرنا أي رؤوس أموال ولا أي حكومات غريبة.',
    arPurple: 'لتمويل نشاطاتنا - نحن بحاجتكم\\ن.',
  },
  // Mobile screen 2: first sentence is a large bold purple heading, the rest is body text.
  mission2: {
    headHe: 'כדי שנצליח לעשות כאן שינוי, אנחנו זקוקים לעזרה ולשותפות של כולנו בבניית עומדים ביחד.',
    bodyHe: 'כל תרומה קטנה עושה שינוי גדול - ההשתתפות שלך, בתרומה חד-פעמית או על ידי הוראת קבע תסייע לנו להוביל את השינוי!',
    headAr: 'كي ننجح بتحقيق التغيير هنا، نحن بحاجة دعم وشراكة الجميع في بناء نقف معًا',
    bodyAr: 'كل تبرع صغير يحقق هنا تغييرا كبيرًا - مشاركتك بالتبرع، لمرة واحدة أو عبر دفعة شهرية تساعدنا بتحقيق التغيير.',
  },
  fields: {
    firstName: { he: 'שם פרטי', ar: 'الاسم الشخصي' },
    lastName: { he: 'שם משפחה', ar: 'اسم العائلة' },
    city: { he: 'יישוב מגורים', ar: 'مكان الاقامة' },
    phone: { he: 'טלפון', ar: 'رقم الهاتف' },
    email: { he: 'דואר אלקטרוני', ar: 'البريد الالكتروني' },
    // The donor-wall message used to be a field here (campaign pages only). It
    // now lives in the thank-you dialog instead — see share.campaign.messagePrompt.
    card: { he: 'מספר אשראי', ar: 'رقم بطاقة الاعتماد' },
    expiry: { he: 'תוקף', ar: 'الصلاحية' },
    cvv: {
      he: '3 ספרות בגב הכרטיס',
      ar: 'آخر ٣ منازل على ظَهر البطاقة',
    },
  },
  consent: {
    he: 'במעבר לתשלום אני מסכים/ה ',
    heTerms: 'לתנאי השימוש',
    ar: 'بالانتقال إلى الدفع، أوافق على ',
    arTerms: 'شروط الاستخدام',
  },
  thanks: { he: 'תודה!', ar: 'شكرًا!' },
  thanksBody: {
    he: 'התרומה התקבלה בהצלחה. יחד נוביל את השינוי.',
    ar: 'تم استلام تبرعكم بنجاح. معًا نقود التغيير.',
  },
  error: {
    he: 'משהו לא עבד. אנא בדקו את הטופס ונסו שוב',
    ar: 'حصل خلل. يرجى فحص النموذج من جديد',
  },
  aside: {
    paragraphs: [
      {
        he: 'עומדים ביחד היא תנועה של פעילים. אין מאחורינו בעלי הון. וגם לא ממשלות זרות. בשביל לממן את הפעילות שלנו - אנחנו צריכים אתכן ואתכם.',
        ar: 'نقف معًا هو حراك مكون من ناشطين. لا يوجد في ظهرنا أي رؤوس أموال ولا أي حكومات غريبة. لتمويل نشاطاتنا - نحن بحاجتكم\\ن.',
      },
      {
        he: 'כדי שנצליח לעשות כאן שינוי, אנחנו זקוקים לעזרה ולשותפות של כולנו בבניית עומדים ביחד. כל תרומה קטנה עושה שינוי גדול - ההשתתפות שלך, בתרומה חד-פעמית או על ידי הוראת קבע תסייע לנו להוביל את השינוי!',
        ar: 'كي ننجح بتحقيق التغيير هنا، نحن بحاجة دعم وشراكة الجميع في بناء نقف معًا. كل تبرع صغير يحقق هنا تغييرا كبيرًا - مشاركتك بالتبرع، لمرة واحدة أو عبر دفعة شهرية تساعدنا بتحقيق التغيير.',
      },
      {
        he: 'עומדים ביחד היא תנועה שנאבקת למען עתיד בטוח בארץ, למען שיטה שסופרת את כולנו, למען חיים בכבוד, בצדק חברתי ובשלום. כי למרות שאנחנו באים ממקומות שונים, למרות שיש לנו זהויות שונות - האינטרסים שלנו משותפים. זה נכון לכולנו, ערבים ויהודים, וזה הופך אותנו לרוב. בעומדים ביחד אנחנו מתארגנים, בונים כוח, ובונים תנועה שתוביל את הדרך לשם. הצטרפו אלינו.',
        ar: 'نقف معًا هو حراك يُناضل من أجل مستقبل آمن في البلاد، من أجل نظام يعمل لصالحنا جميعًا، من أجل حياة كريمة، عدالة اجتماعية وسلام. لأنه على الرغم من أننا نأتي من أماكن مختلفة، إلا أن مصالحنا مشتركة. هذا ينطبق علينا جميعًا، عربًا ويهودًا، وهذا يجعلنا الأغلبية. في نقف معًا، نحن ننتظم، نبني قوة وحراك كي يقود بنا إلى هناك. إنضمّوا إلينا.',
      },
    ],
    bankTitle: {
      he: 'אפשר לתרום לנו בהעברה בנקאית לחשבון שאלה פרטיו:',
      ar: 'يمكنكم التبرع بواسطة حوالة مصرفية على حسابنا:',
    },
    bankLines: [
      { he: 'עומדים ביחד בע"מ (חל"צ)', ar: '' },
      { he: 'בנק לאומי, סניף 806', ar: 'بنك لئومي، فرع ٨٠٦' },
      { he: 'מספר חשבון - 74430057', ar: 'رقم الحساب - ٧٤٤٣٠٠٥٧' },
    ],
    bitTitle: { he: 'ודרך ה״ביט״', ar: 'وعن طريق تطبيق "بيت"' },
    bitLine: { he: 'למספר 058-7725976', ar: 'لرقم تلفون 058-7725976' },
  },
};

// Shared wording for the foreign-currency flow: the currency picker and the
// extra address fields IsraelGives requires for a non-shekel charge. Used
// identically by the donate, join and campaign pages (see
// components/CurrencyPicker.js and components/ForeignAddressFields.js).
export const currencyUi = {
  label: { he: 'מטבע', ar: 'العملة' },
  fields: {
    street: { he: 'רחוב ומספר בית', ar: 'الشارع ورقم البيت' },
    zipCode: { he: 'מיקוד', ar: 'الرمز البريدي' },
    country: { he: 'מדינה', ar: 'الدولة' },
  },
  errors: {
    street: { he: 'יש להזין כתובת يرجى اضافة العنوان' },
    zipCode: { he: 'יש להזין מיקוד يرجى اضافة الرمز البريدي' },
    country: { he: 'יש לבחור מדינה يرجى اختيار الدولة' },
  },
  // Shown under the amount grid on a foreign currency: the charge is made
  // abroad and the donor's bank, not us, decides the conversion.
  foreignNote: {
    he: 'החיוב יתבצע במטבע שנבחר',
    ar: 'سيتم الخصم بالعملة المختارة',
  },
};
